export default __webpack_public_path__ + "static/cardImg2-a9d3e7afd11b85c38eeaea63c958dbda.webp";